import { motion } from "framer-motion";
function ProjectsCard({ text, title, href, href2 }) {
  return (
    <motion.div
      initial={{ scale: 0 }}
      whileInView={{ scale: 1, transition: { type: "easeIn", duration: 0.4 } }}
      whileHover={{ y: -5 }}
      viewport={{ once: true }}
      className="flex flex-col justify-between text-left items-start gap-4 bg-backgroundLighter px-6 py-8 rounded-md w-full"
    >
      <h3 className="font-bold text-lg">{title}</h3>
      <p>{text}</p>
      <div>
        <a className="el-buttonType w-34 mr-4 text-black bg-primary" href={href}>
          view in github
        </a>
        {href2 && (
          <a
            className="px-3 w-auto inline-block py-2 h-auto rounded border border-primary bg-transparent text-primary"
            href={href2}
          >
            live demo
          </a>
        )}
      </div>
    </motion.div>
  );
}

export default ProjectsCard;
